import { createAsync, query } from "@solidjs/router";
import { _listNumbers } from "../roma-api/sms";

export const getSMSNumbers = query(() => _listNumbers(), "sms-numbers");

export const useSMSNumbers = (
  options: { deferStream: boolean } = { deferStream: false }
) => createAsync(() => getSMSNumbers(), options);
